import { defineStore } from 'pinia';

export const useFlightStore = defineStore('flight', {
  state: () => ({
    makeSearchValue: true, // default true
    browserBackValue: true,
  }),
  actions: {
    setMakeSearchValue(value) {
      this.makeSearchValue = value;
    },
    setBrowserBack(value){
      this.browserBackValue = value;
    }
  }
});
